export enum ModalTypes {
  NONE = 'None',
  APPLY = 'APPLY',
}

export enum ModalActionTypes {
  UPDATE_MODAL_TYPE,
}
